import React from 'react'
import PropTypes from 'prop-types'
import ResetPasswordAction from 'components/Actions/ResetPassword'

const ResetPasswordPage = ({ match }) => (
  <ResetPasswordAction token={match.params.token} />
)

ResetPasswordPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default ResetPasswordPage
